<template>
  <div class="popup_in">
    <div class="popup">
      <div class="popup_close_blue">
        <a href="javascript:void(0);" @click="$emit('close')">
          <CloseBlue />
        </a>
      </div>
      <div class="popup-content">
        <div class="title">הפרטים נשלחו בהצלחה</div>
        <!-- <div class="content">או משהו כזה, לורם אימפסום</div> -->
      </div>
    </div>
  </div>
</template>

<script>
import CloseBlue from "../../assets/img/svg/close-blue.svg";
export default {
  components: { CloseBlue }
};
</script>

<style scoped>
.popup {
  border-radius: 60px;
}
.popup-content {
  min-height: 180px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
}

.popup-content .title {
  color: var(--blue);
  font-weight: 400;
  font-size: 36px;
  line-height: 35px;
  text-align: center;
}
.popup-content .content {
  color: var(--blue);
  font-size: 28px;
  line-height: 29px;
  text-align: center;
}
</style>
